import React, { useMemo } from "react";
import { StyleSheet } from "react-native";
import NtTouchableEffect from "./NtTouchableEffect";
import NtText from "./NtText";
import NtMaterialIcon from "./NtMaterialIcon";
import { useTheme } from "../context/ThemeContext";

function NtModalActiveButton({
  enabled = true,
  onPress,
  title,
  containerStyle,
  icon,
  disabled,
}) {
  const { theme } = useTheme();
  const isEnabled = enabled && !disabled;
  const styles = useMemo(() => makeStyles(theme, isEnabled), [theme, isEnabled]);

  // White on the blue brand fill (enabled), themed muted text on the
  // surface3 fill (disabled) so the label stays readable in both light and
  // dark mode.
  const fg = isEnabled ? "#ffffff" : theme.textMute;

  return (
    <NtTouchableEffect
      style={[styles.container, containerStyle]}
      onPress={isEnabled ? onPress : undefined}
    >
      {icon ? (
        <NtMaterialIcon
          name={icon}
          size={13}
          color={fg}
          style={{ marginRight: 5 }}
        />
      ) : null}
      <NtText style={[styles.title, { color: fg }]}>{title}</NtText>
    </NtTouchableEffect>
  );
}

const makeStyles = (t, enabled) =>
  StyleSheet.create({
    container: {
      borderRadius: t.radius,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      paddingHorizontal: 12,
      paddingVertical: 8,
      backgroundColor: enabled ? t.brand : t.surface3,
      borderWidth: 1,
      borderColor: enabled ? t.brand : t.border,
      opacity: enabled ? 1 : 0.7,
    },
    title: { fontSize: 12, fontWeight: "600" },
  });

export default NtModalActiveButton;
